import { render, staticRenderFns } from "./FreightRate.vue?vue&type=template&id=64ac7ef4&scoped=true"
import script from "./FreightRate.vue?vue&type=script&lang=js"
export * from "./FreightRate.vue?vue&type=script&lang=js"
import style0 from "./FreightRate.vue?vue&type=style&index=0&id=64ac7ef4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ac7ef4",
  null
  
)

export default component.exports